.root {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
}

.label {
  overflow-wrap: anywhere;
}

/*
 * The linked entity is a reference under the label: smaller and quieter, still clickable. EntityLink already sets
 * the secondary text colour; no opacity on top, which compounded to a ~3.4:1 contrast that read as a faded option.
 */
.reference {
  font-size: var(--tuna-typography-fontSize-sm);
}
